export default "__VITE_PUBLIC_ASSET__559e8072__"